import React from "react";
import { Pagination, Table, Tag } from "antd";
import dayjs from "dayjs";
const UsageTable = ({
  eventsData,
  titleData,
  TAB_COLORS,
  TAB_TO_KIND,
  TAB_FILTERS,
  onPageChange,
  currentPage,
  defaultRole,
}) => {
  const columns = [
    {
      title: "Timestamp",
      dataIndex: "created_at",
      key: "created_at",

      render: (v) => (
        <span style={{ color: "#374151", fontSize: 13 }}>
          {dayjs(v).format("DD MMM YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Source",
      dataIndex: "kind",
      key: "kind",
      render: (value) => {
        const tab = Object.keys(TAB_TO_KIND).find(
          (key) => TAB_TO_KIND[key] === value
        );
        const col = TAB_COLORS[tab];
        return col ? (
          <Tag
            style={{
              background: col.bg,
              color: col.text,
              border: `1px solid ${col.border}`,
              borderRadius: 10,
              padding: "2px 10px",
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            {tab}
          </Tag>
        ) : (
          <span>{value}</span>
        );
      },
    },
    ...(defaultRole !== "Facility_Admin"
      ? [
          {
            title: "Facility",
            dataIndex: "facility_name",
            key: "facility_name",

            render: (v) => (
              <span style={{ color: "#374151", fontSize: 13 }}>{v}</span>
            ),
          },
        ]
      : []),
    {
      title: "Log",
      dataIndex: "log",
      key: "log",
      render: (v) => (
        <span style={{ color: "#374151", fontSize: 13 }}>{v}</span>
      ),
    },
  ];

  return (
    <>
      <Table
        scroll={{ y: "calc(100vh - 230px)" }}
        bordered
        dataSource={eventsData?.results}
        columns={columns}
        pagination={false}
        rowKey="key"
        styles={{ title: { backgroundColor: "#ffffff", padding: "12px 16px" } }}
        {...(titleData && typeof titleData === "function"
          ? { title: titleData }
          : {})}
      />{" "}
      {eventsData?.total_count > 100 && (
        <div className="flex-center" style={{ paddingTop: "10px" }}>
          <Pagination
            current={currentPage}
            pageSize={100}
            total={eventsData?.total_count}
            onChange={(e) => onPageChange(e)}
            showSizeChanger={false}
          />
        </div>
      )}
    </>
  );
};

export default UsageTable;
